import { Button } from "@rio-cloud/rio-uikit";
import Card from "@rio-cloud/rio-uikit/Card";
import BarList from "@rio-cloud/rio-uikit/BarList";
import { RevenueCategory } from "../../../types/dashboard";
import { formatValue } from "../../../utils/format";

interface CategoryCardProps {
  title: string;
  categories: RevenueCategory[];
  addButtonText: string;
  onViewClick?: () => void;
  onAddClick?: () => void;
  emptyStateText?: string;
}

export default function CategoryCard({
  title,
  categories,
  addButtonText,
  onViewClick,
  onAddClick,
  emptyStateText,
}: CategoryCardProps) {
  const barListData = [...categories]
    .sort((a, b) => b.value - a.value)
    .slice(0, 5)
    .map((category) => ({
      key: category.name,
      name: category.name,
      value: category.value,
      ...(category.color && { barColor: category.color }),
    }));

  const hasCategories = barListData.length > 0;
  const defaultEmptyStateText = emptyStateText ?? "Nenhuma categoria cadastrada no período";

  return (
    <Card className="padding-20 padding-x-50">
      <span className="text-size-16 text-bold">{title}</span>

      {hasCategories ? (
        <BarList
          showAnimation
          rowHeight={30}
          data={barListData}
          className="margin-y-20"
          background="bg-lightest"
          color="text-color-darker"
          barColor="bg-coldplay-moos"
          valueFormatter={(value) => <span className="text-color-dark text-align-right">{formatValue(value)}</span>}
        />
      ) : (
        <div className="display-flex flex-column justify-content-center align-items-center gap-10 margin-y-20">
          <span
            aria-hidden="true"
            style={{ fontSize: "84px" }}
            className="rioglyph rioglyph-looking-glass-man text-color-light"
          />
          <span className="text-size-14 text-color-dark text-center">{defaultEmptyStateText}</span>
        </div>
      )}

      <div className="display-flex align-items-center gap-10">
        <Button bsStyle="primary" className="action-button" onClick={onAddClick}>
          <span className="rioglyph rioglyph-plus-light" aria-hidden="true" />
          <span>{addButtonText}</span>
        </Button>
        <Button bsStyle="primary" className="action-button" onClick={onViewClick}>
          <span className="rioglyph rioglyph-search-list" aria-hidden="true" />
          <span>Ver todos</span>
        </Button>
      </div>
    </Card>
  );
}
